module.exports = __webpack_public_path__ + "img/zhwswxhmyx.6bfbbc12.png";